export const notDeleted = <T extends { isDeleted: boolean }>(value: T) =>
  !value.isDeleted;
